import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getStoredUser } from "../services/api/auth";
import { isAuthenticated } from "../services/api/client";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ("admin" | "staff" | "finance" | "partner")[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const location = useLocation();
  const auth = isAuthenticated();
  const user = getStoredUser();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
